import React from "react"
// material-ui
import { ListItem } from "material-ui/List"
import { darkBlack } from "material-ui/styles/colors"


const Note = ({
    name = "",
    date = "",
    text = ""
}) => (
    <ListItem
        primaryText={ text }
        secondaryText={
            <p>
              <span style={{ color: darkBlack }}>{ name }</span><br />
              { date }
            </p>
          }
        secondaryTextLines={ 2 }
        style={{ cursor: "default" }}
    />
)

export default Note


/** WEBPACK FOOTER **
 ** ./src/components/person/Notes/note.js
 **/